// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"26895fce","213":"52689516","239":"999ec95d","452":"c00e1c84","553":"ec0384e6"}[chunkId] + ".chunk.js";
};